import type { FlagsType } from '@iheartjane/feature-flags';
import { useEffect, useRef } from 'react';

import { registerMixpanelIdentity } from '@jane/bloom/services/tracking/mixpanel';

type UseMixpanelRegistrationParams = {
  buildVersion: string;
  featureFlags?: FlagsType;
  operatorId: number;
  operatorName: string;
  pluginVersion?: string;
  projectToken?: string | null;
  storeCity?: string;
  storeId?: number;
  storeName?: string;
  storeState?: string;
  uniqueId: string;
};

/**
 * Registers user identity and super properties with Mixpanel.
 * Re-registers when uniqueId changes (e.g., user logs in/out).
 */
export function useMixpanelRegistration({
  projectToken,
  storeCity,
  storeId,
  storeName,
  storeState,
  uniqueId,
  ...rest
}: UseMixpanelRegistrationParams) {
  const registeredUniqueIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (
      projectToken &&
      storeCity &&
      storeId &&
      storeName &&
      storeState &&
      uniqueId !== registeredUniqueIdRef.current
    ) {
      registeredUniqueIdRef.current = uniqueId;

      registerMixpanelIdentity({
        storeCity,
        storeId,
        storeName,
        storeState,
        uniqueId,
        ...rest,
      });
    }
  }, [projectToken, rest, storeCity, storeId, storeName, storeState, uniqueId]);
}
